import React, { useEffect, useRef } from 'react';
export function LineageGraph() {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  useEffect(() => {
    if (!canvasRef.current) return;
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    // Set canvas dimensions
    const resizeCanvas = () => {
      const container = canvas.parentElement;
      if (container) {
        canvas.width = container.clientWidth;
        canvas.height = container.clientHeight;
      }
    };
    resizeCanvas();
    window.addEventListener('resize', resizeCanvas);
    // Draw the graph
    const drawGraph = () => {
      if (!ctx) return;
      // Clear canvas
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      // Define nodes
      const nodes = [{
        id: 'borrower',
        label: 'Borrower Input',
        x: 50,
        y: canvas.height / 2,
        color: '#EFF6FF',
        textColor: '#1E40AF',
        borderColor: '#93C5FD'
      }, {
        id: 'officer',
        label: 'Loan Officer',
        x: 200,
        y: canvas.height / 2,
        color: '#EFF6FF',
        textColor: '#1E40AF',
        borderColor: '#93C5FD'
      }, {
        id: 'appraisal',
        label: 'Appraisal Doc',
        x: 350,
        y: canvas.height / 2,
        color: '#EFF6FF',
        textColor: '#1E40AF',
        borderColor: '#93C5FD'
      }, {
        id: 'agent',
        label: 'Structuring Agent',
        x: 500,
        y: canvas.height / 2,
        color: '#EFF6FF',
        textColor: '#1E40AF',
        borderColor: '#93C5FD'
      }, {
        id: 'final',
        label: 'Final Value',
        x: 650,
        y: canvas.height / 2,
        color: '#ECFDF5',
        textColor: '#065F46',
        borderColor: '#6EE7B7'
      }];
      // Draw connections
      ctx.beginPath();
      ctx.moveTo(nodes[0].x + 80, nodes[0].y);
      for (let i = 1; i < nodes.length; i++) {
        ctx.lineTo(nodes[i].x - 80, nodes[i].y);
        if (i < nodes.length - 1) {
          ctx.moveTo(nodes[i].x + 80, nodes[i].y);
        }
      }
      ctx.strokeStyle = '#CBD5E1';
      ctx.lineWidth = 2;
      ctx.stroke();
      // Draw nodes
      nodes.forEach(node => {
        // Draw node background
        ctx.beginPath();
        ctx.roundRect(node.x - 80, node.y - 20, 160, 40, 8);
        ctx.fillStyle = node.color;
        ctx.fill();
        ctx.strokeStyle = node.borderColor;
        ctx.lineWidth = 2;
        ctx.stroke();
        // Draw node text
        ctx.fillStyle = node.textColor;
        ctx.font = '14px Arial';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(node.label, node.x, node.y);
      });
      // Draw values
      const values = [{
        label: '$850,000',
        x: 125,
        y: canvas.height / 2 - 40
      }, {
        label: '$850,000',
        x: 275,
        y: canvas.height / 2 - 40
      }, {
        label: '$873,500',
        x: 425,
        y: canvas.height / 2 - 40
      }, {
        label: '$875,000',
        x: 575,
        y: canvas.height / 2 - 40
      }];
      values.forEach(value => {
        ctx.fillStyle = '#1F2937';
        ctx.font = '12px Arial';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(value.label, value.x, value.y);
        // Draw connecting line
        ctx.beginPath();
        ctx.moveTo(value.x, value.y + 5);
        ctx.lineTo(value.x, canvas.height / 2 - 25);
        ctx.strokeStyle = '#CBD5E1';
        ctx.lineWidth = 1;
        ctx.stroke();
      });
    };
    drawGraph();
    return () => {
      window.removeEventListener('resize', resizeCanvas);
    };
  }, []);
  return <canvas ref={canvasRef} className="w-full h-full" data-id="element-975" />;
}